import React, { useState } from "react";
import { Guest, Room } from "./HotelBookingPage";

interface Step4Props {
  checkIn: Date;
  checkOut: Date;
  selectedRoom: Room;
  occupancy: string;
  rooms: number;
  guests: Guest[];
  airportTransfer: boolean;
  paymentOption: string;
  onBack: () => void;
  onConfirm: () => void;
}

const Step4: React.FC<Step4Props> = ({
  checkIn,
  checkOut,
  selectedRoom,
  occupancy,
  rooms,
  guests,
  airportTransfer,
  paymentOption,
  onBack,
  onConfirm,
}) => {
  const nights = (checkOut.getTime() - checkIn.getTime()) / (1000 * 3600 * 24);
  const [loading, setLoading] = useState(false);

  const getRate = (occupancy: "Single" | "Double") =>
    occupancy === "Double" ? selectedRoom.double : selectedRoom.single;

  // Calculate the total price
  const totalPrice =
    guests.reduce((sum, guest) => {
      return sum + getRate(guest.occupancy) * nights;
    }, 0) + (airportTransfer ? 130 : 0); // Add AED 450 if airport transfer is selected

  const isMobile = window.innerWidth <= 768;
  return (
    <div className="step2-container">
      <div className="step2-content">
        <div className="room-info">
          <div className="room-info-card">
            <div className="image-wrapper">
              {(selectedRoom.limitSingle != null ||
                selectedRoom.limitDouble != null) && (
                <div className="badge-row">
                  <span className="badge limited">Limited Slots</span>
                </div>
              )}
              <img src={selectedRoom.image} alt={selectedRoom.name} />
            </div>
            <div className="content">
              <h3>{selectedRoom.name}</h3>
              <div style={{ fontSize: 14, color: "#333" }}>
                <div className="prices">
                  <div className="price-row">
                    <span>Total nights</span>
                    <span className="price">{nights} nights</span>
                  </div>
                  <div className="price-row">
                    <span>Total Guests</span>
                    <span className="price">
                      {guests.length +
                        guests.filter(
                          (g) =>
                            g.occupancy === "Double" &&
                            g.companionFirstName?.trim()
                        ).length}
                    </span>
                  </div>
                  <div className="price-row">
                    <span>No. of Rooms</span>
                    <span className="price">{rooms}</span>
                  </div>

                  {/* Display Airport Transfer Fee if Yes */}
                  {airportTransfer && (
                    <div className="price-row">
                      <span>Airport Transfer (USD)</span>
                      <span className="price">$130.00</span>
                    </div>
                  )}
                </div>

                {/* Guest details */}
                {guests.map((guest, i) => {
                  const rate =
                    guest.occupancy === "Double"
                      ? selectedRoom.double
                      : selectedRoom.single;
                  const subtotal = rate * nights;

                  return (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        color: "#ADADAD",
                        marginBottom: 6,
                        paddingLeft: 24,
                      }}
                    >
                      <span>
                        Room {i + 1} ({guest.occupancy})
                      </span>
                      <span>
                        $
                        {rate.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{" "}
                        × {nights} nights = $
                        {subtotal.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  );
                })}

                <div
                  style={{
                    borderTop: "1px solid #ddd",
                    marginTop: 12,
                    marginBottom: 8,
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontWeight: 700,
                    fontSize: 16,
                    color: "#16a34a",
                  }}
                >
                  <span>Total</span>
                  <span>
                    $
                    {totalPrice.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </div>
              </div>
              <p className="note">
                All rates include breakfast and applicable taxes.
              </p>
            </div>
          </div>
        </div>

        <div className="form-container">
          <div className="form-row-dates-inline">
            <div className="form-group-dates">
              <label>Check-in</label>
              <label className="check-in-label">
                {checkIn.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </label>
            </div>
            <div className="form-group-dates">
              <label>Check-out</label>
              <label className="check-in-label">
                {checkOut.toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
              </label>
            </div>
          </div>

          <div>
            <div
              className="form-row"
              style={{
                display: "flex",
                flexDirection: "column",
                // gap: 10,
                width: "100%",
              }}
            >
              {/* <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      gap: 12,
                      flexWrap: "wrap",
                    }}
                  >
                    <div style={{ flex: "0 0 180px" }}>
                      <label
                        htmlFor="rooms"
                        style={{
                          display: "block",
                          fontWeight: 600,
                          marginBottom: 2,
                          width: isMobile ? "100%" : "320px",
                          fontSize: 14,
                        }}
                      >
                        Do you require an airport transfer?
                      </label>
                      <label>{airportTransfer ? "Yes" : "No"}</label>
                    </div>
                  </div> */}
            </div>
            <div className="form-row">
              <label
                htmlFor="rooms"
                style={{
                  display: "block",
                  fontWeight: 600,
                  marginBottom: 2,
                  width: isMobile ? "100%" : "320px",
                  fontSize: 14,
                }}
              >
                How would you like to pay?
              </label>
              <label>{paymentOption}</label>
            </div>
          </div>
          <h4 className="guest-title-details" style={{ paddingBottom: 20 }}>
            Guest Summary
          </h4>

          {guests.map((guest, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#f7f6f9",
                padding: 20,
                borderRadius: 12,
                marginBottom: 20,
              }}
            >
              <h4
                className="guest-title"
                style={{ display: "flex", alignItems: "center", gap: 10 }}
              >
                Room {index + 1}
                {guest.primary && (
                  <span
                    style={{
                      border: "1px solid #16a34a",
                      color: "#16a34a",
                      padding: "2px 8px",
                      borderRadius: 999,
                      fontSize: 12,
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    Primary
                  </span>
                )}
              </h4>

              <div className="form-row">
                <label style={{ width: "25%", fontWeight: 600 }}>Name</label>
                <label>
                  {guest.title} {guest.firstName} {guest.lastName}
                </label>
              </div>

              <div className="form-row">
                <label style={{ width: "25%", fontWeight: 600 }}>
                  Occupancy
                </label>
                <label>{guest.occupancy}</label>
              </div>

              <div className="form-row">
                <label style={{ width: "25%", fontWeight: 600 }}>
                  Mobile Number
                </label>
                <label>{guest.mobile}</label>
              </div>

              <div className="form-row">
                <label style={{ width: "25%", fontWeight: 600 }}>
                  Email Address
                </label>
                <label>{guest.email}</label>
              </div>

              {(guest.companionFirstName || guest.companionLastName) && (
                <div className="form-row">
                  <label style={{ width: "25%", fontWeight: 600 }}>
                    Companion
                  </label>
                  <label>
                    {guest.companionTitle} {guest.companionFirstName}{" "}
                    {guest.companionLastName}
                  </label>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <div
        className="inline-button-group next-button"
        style={{
          backgroundColor: "#fff",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <button onClick={onBack}>Back: Guest Details</button>
        <button
          disabled={loading}
          onClick={() => {
            setLoading(true);
            onConfirm();
          }}
        >
          {loading ? "Processing..." : "Submit"}
        </button>
      </div>

      <div
        className="floating-button-group"
        style={{
          backgroundColor: "#fff",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <button onClick={onBack}>Back</button>
        <button
          disabled={loading}
          onClick={() => {
            setLoading(true);
            onConfirm();
          }}
        >
          {loading ? "Processing..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default Step4;
